module.exports = __webpack_public_path__ + "img/img31.64dd00f5.svg";